import React, { useState, useEffect } from 'react';
import UserServices from '../services/UserServices';
import useAsync from '../hooks/useAsync';

function Contect() {
  const { data, error, isLoading } = useAsync(UserServices.getContactDetail);


  const [formValues, setFormValues] = useState({
    phone: '',
    youtube: '',
    whatsApp: '',
    faceBook: '',
    linkedin: '',
    instagram: '',
    twitter: ''
  });

  // Update form values when data is fetched
  useEffect(() => {
    if (data.data) {
      setFormValues({
        youtube: data.data.youtube || '',
        phone: data.data.phone || '',
        whatsApp: data.data.whatsApp || '',
        faceBook: data.data.faceBook || 'https://',
        linkedin: data.data.linkedin || 'https://',
        instagram: data.data.instagram || 'https://',
        twitter: data.data.twitter || 'https://'
      });
    }
  }, [data]);

  // Handle form input changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value
    });
  };

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {


      await UserServices.updateContactDetail(data.data._id, formValues);
      alert('Contact details updated successfully');
    } catch (error) {
      console.error('Failed to update contact details', error);
      alert('Failed to update contact details');
    }
  };

  if (isLoading) {
    return <div className="loader design_loading">Loading...</div>;
  }

  if (error) {
    return <div>Error loading contact details</div>;
  }

  return (
    <div className="right_col" role="main">
      <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

        <div className="my-auto">

          <h5 className="page-title fs-21 mb-1">
            Contact us            </h5>
          <nav>

            <ol className="breadcrumb mb-0">

              <li className="breadcrumb-item">
                <a href="javascript:void(0);">Home</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Contact us
              </li>
            </ol>
          </nav>
        </div>
        <div className="d-flex my-xl-auto gap-2 right-content align-items-center">

        </div>
      </div>

      <div className="container-box">
        <div className="container-box-inner table-reponsive-tabe">
          <div className="page-details">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-sm-6">
                  <div className="input-field">
                    <label>Phone</label>
                    <input
                      type="text"
                      name="phone"
                      maxLength={10}
                      className="form-control"
                      value={formValues.phone}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="input-field">
                    <label>Whatsapp</label>
                    <input
                      type="text"
                      name="whatsApp"
                      className="form-control"
                      value={formValues.whatsApp}
                      onChange={handleInputChange}
                      maxLength={10}
                    />
                  </div>
                </div>
                <div className="col-sm-12">
                  <div className="input-field">
                    <label>Facebook Link</label>
                    <div className="input-link-outer">
                      <input
                        type="text"
                        name="faceBook"
                        className="form-control"
                        value={formValues.faceBook}
                        onChange={handleInputChange}
                      />
                      <button type="button" className="link-copy-btn"><i className="fa fa-paperclip" /></button>
                    </div>
                  </div>
                </div>

                <div className="col-sm-12">
                  <div className="input-field">
                    <label>Instagram Link</label>
                    <div className="input-link-outer">
                      <input
                        type="text"
                        name="instagram"
                        className="form-control"
                        value={formValues.instagram}
                        onChange={handleInputChange}
                      />
                      <button type="button" className="link-copy-btn"><i className="fa fa-paperclip" /></button>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12">
                  <div className="input-field">
                    <label>Linkedin Link</label>
                    <div className="input-link-outer">
                      <input
                        type="text"
                        name="linkedin"
                        className="form-control"
                        value={formValues.linkedin}
                        onChange={handleInputChange}
                      />
                      <button type="button" className="link-copy-btn"><i className="fa fa-paperclip" /></button>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12">
                  <div className="input-field">
                    <label>Twitter Link</label>
                    <div className="input-link-outer">
                      <input
                        type="text"
                        name="twitter"
                        className="form-control"
                        value={formValues.twitter}
                        onChange={handleInputChange}
                      />
                      <button type="button" className="link-copy-btn"><i className="fa fa-paperclip" /></button>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12">
                  <div className="input-field">
                    <label>Youtube Link</label>
                    <div className="input-link-outer">
                      <input
                        type="text"
                        name="youtube"
                        className="form-control"
                        value={formValues.youtube}
                        onChange={handleInputChange}
                      />
                      <button type="button" className="link-copy-btn"><i className="fa fa-paperclip" /></button>
                    </div>
                  </div>
                </div>
              </div>
              <button type="submit" className="submit-green-btn">SUBMIT</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contect;
